import { GlobalMailTemplate, MailTemplateType } from '@adornis/buchungsheld-db/entities/mail-templates.js';
import { TrMailsTemplateEditor } from '@adornis/buchungsheld-theme/components/tr-mails-template-editor.js';
import '@adornis/buchungsheld-theme/fonts/fonts.js';
import { css } from '@adornis/chemistry/directives/css.js';
import type { MailTemplate } from '@adornis/mails/db/mail-template.js';
import { html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import './matching-mail-editor.js';

/**
 * @element matching-mails-template-editor
 */
@customElement('matching-mails-template-editor')
export class TrBuddyMailsTemplateEditor extends TrMailsTemplateEditor {
  protected override editSection(selectedTemplate: MailTemplate) {
    return html`
      <tr-flex space="md">
        <tr-flex horizontal space="md" flex>
          <tr-flex
            ${css({ background: '#fff', borderRadius: '5px', padding: this.spacing.lg, marginBottom: this.spacing.md })}
            space="md"
            flex
          >
            <tr-text bold> Beschreibung: </tr-text>
            <tr-text>
              ${GlobalMailTemplate.getMailHint(selectedTemplate.emailType as any as MailTemplateType)}
            </tr-text>
          </tr-flex>

          ${(() => {
            // TODO: are notification settings needed in matching?
            return nothing;
            // return this._notificationTypeSelection()
          })()}
        </tr-flex>
        <matching-mail-editor
          .value=${selectedTemplate}
          ?clearable=${this.clearable}
          ?overriding=${this.overriding}
          attachments
        ></matching-mail-editor>
      </tr-flex>
    `;
  }
}
